// extracted by mini-css-extract-plugin
module.exports = {"notfound":"notfound_notfound__1eqrp","notfound404":"notfound_notfound404__2Wx1U","notfound-404":"notfound_notfound-404__2fiEv"};